module.exports = __webpack_public_path__ + "img/snowy-1.f78cba60.svg";